(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-editorial"]) return;
  try {
    
  if (!customElements.get('tlh-editorial')) {
    customElements.define('tlh-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const body = this.querySelector('.tlh-editorial__body');
        if (!body) return;
        body.querySelectorAll('table').forEach((table) => {
          let wrapper = table.parentElement;
          if (!wrapper.classList.contains('tlh-table-wrap')) {
            wrapper = document.createElement('div');
            wrapper.className = 'tlh-table-wrap';
            table.before(wrapper);
            wrapper.append(table);
          }
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('tabindex', '0');
          if (!wrapper.hasAttribute('aria-label') && !wrapper.hasAttribute('aria-labelledby')) wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || this.dataset.tableLabel);
        });
        body.querySelectorAll('iframe').forEach((frame) => {
          if (!/^(https?:)?\/\/(www\.)?(youtube\.com|youtube-nocookie\.com|player\.vimeo\.com)\//.test(frame.getAttribute('src') || '')) return;
          if (frame.closest('.tlh-embed')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'tlh-embed';
          frame.before(wrapper);
          wrapper.append(frame);
        });
        const rail = this.querySelector('.tlh-editorial__rail');
        if (!rail) return;
        const depth = Math.min(4, Math.max(2, Number(this.dataset.tocDepth) || 2));
        const selector = Array.from({ length: depth - 1 }, (_, index) => `h${index + 2}`).join(',');
        const headings = [...body.querySelectorAll(selector)].filter((heading) => heading.textContent.trim());
        if (headings.length < 3) return;
        const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
        const list = rail.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `editorial-section-${index + 1}`;
            while (usedIds.has(id)) id += '-section';
            heading.id = id;
            usedIds.add(id);
          }
          const item = document.createElement('li');
          if (heading.tagName !== 'H2') item.className = 'tlh-editorial__toc-sub';
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        rail.hidden = false;
        const disclosure = rail.querySelector('details');
        this.breakpoint = matchMedia('(min-width: 1100px)');
        this.onBreakpoint = () => { disclosure.open = this.breakpoint.matches; };
        this.onBreakpoint();
        this.breakpoint.addEventListener('change', this.onBreakpoint);
        this.tocList = list;
        this.onTocClick = (event) => {
          const link = event.target.closest('a');
          if (!link) return;
          list.querySelectorAll('[aria-current]').forEach((item) => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
          const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
          if (target) {
            if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }
        };
        list.addEventListener('click', this.onTocClick);
      }
      disconnectedCallback() {
        if (this.breakpoint && this.onBreakpoint) this.breakpoint.removeEventListener('change', this.onBreakpoint);
        this.tocList?.removeEventListener('click', this.onTocClick);
        this.initialized = false;
        this.querySelector('.tlh-editorial__toc')?.replaceChildren();
        const rail = this.querySelector('.tlh-editorial__rail');
        if (rail) rail.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
